import React, { useState, useEffect } from "react";
import { Table, Image, Button, Modal } from "react-bootstrap";
import Media from "react-media";
import { NavLink } from "react-router-dom";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { ReusableOnboardingButton } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { connect, useDispatch } from "react-redux";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import {
  delete_item_from_category,
  vendor_copy_items_from_catalog,
} from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  CATALOG_SELECTED_CATEGORIES_ITEMS,
  SELECTED_CATALOG_ITEMS,
  SELECTED_ITEMS_ID,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
} from "../../../../../../../store/types";
import { useHistory } from "react-router-dom";
import Alert from "react-s-alert";
import { vendor_show_local_menu_items } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { ITEMTYPEVEG } from "../../../../../../../enums/OrderEnums";

const SelectedItemsNew = (props) => {
  // const onClickSubmit = (e) => {
  //   props.history.push({
  //     pathname: "/casual-fine-dining/menusetup/selectmenu/selectitemsnew",
  //   });
  // };

  let history = useHistory();
  const dispatch = useDispatch();

  const onSuccessRedirectToMenu = () => {
    if (props.dash) {
      history.push("/menusetup-dashboard");
    } else {
      history.push("/casual-fine-dining/menusetup");
    }

    Alert.success(`<h4> Item Updated Sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onClickSubmit = () => {
    var categoryId = [];
    for (let i = 0; i < props.all_local_catalog_items.length; i++) {
      if (
        props.selectedItemsId.includes(props.all_local_catalog_items[i]._id)
      ) {
        categoryId.push(props.all_local_catalog_items[i].category._id);
      }
    }
    var finalCategory = [];
    for (
      let j = 0;
      j < props.catalogSelectedCategoriesItems.category.length;
      j++
    ) {
      if (
        categoryId.includes(
          props.catalogSelectedCategoriesItems.category[j].categoryId
        )
      ) {
        finalCategory.push({
          categoryId:
            props.catalogSelectedCategoriesItems.category[j].categoryId,
          is_temp_local: false,
        });
      } else {
        finalCategory.push({
          categoryId:
            props.catalogSelectedCategoriesItems.category[j].categoryId,
          is_temp_local: true,
        });
      }
    }
    props.catalogSelectedCategoriesItems.category = finalCategory;
    const token = props.auth.user.accessToken;
    props.vendor_copy_items_from_catalog(
      token,
      props.catalogSelectedCategoriesItems,
      onSuccessRedirectToMenu
    );
  };

  const [showDeleteCategory, setShowDeleteCategory] = useState(false);
  const [itemId, setItemId] = useState("");
  const handleCloseDeleteItem = () => {
    setShowDeleteCategory(false);
  };
  const onClickShowDeleteCategory = (id) => {
    setItemId(id);
    setShowDeleteCategory(true);
  };

  const onSuccess = () => {
    // const token = props.auth.user.accessToken;
    // const vendorId = props.auth.user.VendorUser._id;
    // props.vendor_show_local_menu_category(token, vendorId);
    let updatedSelectedItemId = [...props.selectedItemsId];
    let updatedSelectedItems = [...props.selectedCatalogItems];
    let updatedCatalogSelectedCategoriesItems = {
      ...props.catalogSelectedCategoriesItems,
    };
    let updatedItems = [...props.catalogSelectedCategoriesItems.items];

    updatedSelectedItemId = updatedSelectedItemId.filter(
      (item) => item !== itemId
    );
    updatedSelectedItems = updatedSelectedItems.filter(
      (item) => item._id !== itemId
    );
    updatedItems = updatedItems.filter((item) => item.itemId !== itemId);

    //updatedCatalogSelectedCategoriesItems.items = updatedItems;
    props.catalogSelectedCategoriesItems.items = updatedItems;

    dispatch({ type: SELECTED_CATALOG_ITEMS, payload: updatedSelectedItems });
    dispatch({ type: SELECTED_ITEMS_ID, payload: updatedSelectedItemId });
    dispatch({
      type: CATALOG_SELECTED_CATEGORIES_ITEMS,
      payload: props.catalogSelectedCategoriesItems,
    });
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.vendor_show_local_menu_items(token, vendorId);
    handleCloseDeleteItem();
    Alert.error(`<h4>Items Deleted Sucessfully </h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onClickYesDeleteItem = () => {
    const token = props.auth.user.accessToken;
    props.delete_item_from_category(itemId, token, onSuccess);
  };

  const takeToEditPage = (item) => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: item._id });
    if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push("/additemavailablity/catalogverified");
    } else {
      history.push("/casual-fine-dining/menusetup/additem/catalog");
    }
  };

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    let itemsArray = [];
    for (let i = 0; i < props.all_local_catalog_items.length; i++) {
      if (
        props.selectedItemsId.includes(props.all_local_catalog_items[i]._id)
      ) {
        itemsArray.push(props.all_local_catalog_items[i]);
      }
    }
    setFilteredItems(itemsArray);
  }, [props.all_local_catalog_items]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.vendor_show_local_menu_items(token, vendorId);
  }, []);
  const displayMain = () => {
    return (
      <div
        className={`${
          !props.dash && `onboarding_process_screen-button-map`
        } d-flex justify-content-between flex-column`}
      >
        <div>
          <TopTextReusableComponent
            headingText="Selected Items"
            headingParagraph="Edit item details before submitting"
          />
        </div>
        <Media query="(min-width: 992px)">
          <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
            <Table className="w-100 HideShowTable">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: "15%" }} className="f11-500">
                    Item
                    <br />
                    ID
                  </th>
                  <th style={{ width: "20%" }} className="f11-500">
                    Item Name
                  </th>
                  <th style={{ width: "15%" }} className="f11-500">
                    Item Category
                  </th>
                  <th style={{ width: "15%" }} className="f11-500">
                    Crusine Type
                  </th>
                  <th style={{ width: "15%" }} className="f11-500">
                    Description
                  </th>
                  <th style={{ width: "20%" }} className="f11-500">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item, index) => (
                  <tr className="super_admin_all_users_table_body" key={index}>
                    {console.log(item)}
                    <td style={{ width: "15%" }}>
                      <div className="f14-500 text-break">#ID {item._id}</div>
                      <div className="enIMG62 mt-2">
                        <Image
                          //src={require("../../../../../../../assets/images/UserManagement/items.png")}
                          src={item && item.images && item.images[0]}
                          alt="item img"
                          title="item img"
                          fluid
                          width="100%"
                          height="100%"
                        />
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="d-flex mt-2 align-items-center">
                        {ITEMTYPEVEG.map((type, index) => {
                          return (
                            <React.Fragment key={index}>
                              {item?.itemType === type?.value ? (
                                <Image
                                  width="16px"
                                  src={type.url}
                                  alt={type.title}
                                  title={type.title}
                                  className="vegIcon"
                                  fluid
                                />
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                        {/* <Image
                          src={
                            item && item?.itemType === 0
                              ? require("../../../../../../../assets/images/superadmin/ordericon/veg.svg")
                              : item && item?.itemType === 1
                              ? require("../../../../../../../assets/images/superadmin/ordericon/non veg.svg")
                              : item && item?.itemType === 2
                              ? require("../../../../../../../assets/images/superadmin/ordericon/Egg.svg")
                              : null
                          }
                          //src={require("../../../../../assets/images/UserManagement/veg.svg")}
                          alt={
                            item && item?.itemType === 0
                              ? "Veg"
                              : item && item?.itemType === 1
                              ? "Non-Veg"
                              : item && item?.itemType === 2
                              ? "Egg"
                              : null
                          }
                          title={
                            item && item?.itemType === 0
                              ? "Veg"
                              : item && item?.itemType === 1
                              ? "Non-Veg"
                              : item && item?.itemType === 2
                              ? "Egg"
                              : null
                          }
                          fluid
                          width="16px"
                          className="vegIcon"
                        /> */}
                        <div className="f14-500 pl-2 text-break">
                          {item.name}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex mt-2 align-items-center">
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/vegan.svg")}
                          src={
                            item &&
                            item.primary_food_type &&
                            item.primary_food_type.icon
                          }
                          alt="icon"
                          title="icon"
                          fluid
                          width="16px"
                          className="vegIcon"
                        />
                        <div className="f14-500 pl-2">
                          {" "}
                          {item &&
                            item.primary_food_type &&
                            item.primary_food_type.title}
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f14-500">
                        {item.category && item.category.name}
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f11-500">
                        {item && item.cuisin_type && item.cuisin_type.title}
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f11-500">{item.description}</div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() => onClickShowDeleteCategory(item._id)}
                        >
                          <Image
                            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                            alt="delete item"
                            title="delete item"
                            fluid
                          />
                        </Button>

                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() => takeToEditPage(item)}
                        >
                          <Image
                            src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="edit item"
                            title="edit item"
                            fluid
                          />
                        </Button>
                        {/* <NavLink
                      to="/casual-fine-dining/menusetup/selectmenu/editcategories"
                      variant="link"
                      className="enIconBtn mr-3"
                    >
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </NavLink> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Media>
        <Media query="(max-width: 991px)">
          <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
            <Table className="w-100">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: "25%" }} className="f11-500">
                    Item
                    <br />
                    ID
                  </th>
                  <th style={{ width: "15%" }} className="f11-500">
                    Item Icon
                  </th>
                  <th style={{ width: "20%" }} className="f11-500">
                    Item Name
                  </th>
                  <th style={{ width: "40%" }} className="f11-500">
                    Category
                  </th>
                </tr>
              </thead>

              {filteredItems.map((item, index) => (
                <Accordian item={item} key={index} />
              ))}
            </Table>
          </div>
        </Media>
        <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
          <div>
            {/* <ReusableOnboardingLink
          buttonTitle="Back Button"
          buttonClass="btn-lg btn btn-outline-secondary"
          buttonText="Cancel"
          link="/casual-fine-dining/menusetup"
        /> */}
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
              buttonText="Submit"
              buttonType="Submit"
              onClick={onClickSubmit}
            />
          </div>
        </div>
      </div>
    );
  };
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            {props.dash ? (
              displayMain()
            ) : (
              <div className="row">
                <div
                  id="onboarding-scrollbar"
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
                >
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        backButtonClicked={
                          "/casual-fine-dining/menusetup/selectmenu/selectitemsnew"
                        }
                        notDisplaProgressBar={true}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader
                      link={true}
                      onLink={
                        "/casual-fine-dining/menusetup/selectmenu/selectitemsnew"
                      }
                    />
                  </Media>
                  {displayMain()}
                </div>
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                  <SliderReusableComponent
                    // displayBarButton={true}
                    displayHamburger={true}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
                  />
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
      <Modal show={showDeleteCategory} onHide={handleCloseDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this Item ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={handleCloseBlockUser}
            onClick={() => onClickYesDeleteItem()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  all_local_catalog_items: state.superAdminOnboarding.all_local_catalog_items,
  selectedItemsId: state.superAdminOnboarding.selectedItemsId,
  selectedCatalogItems: state.superAdminOnboarding.selectedCatalogItems,
  catalogSelectedCategoriesItems:
    state.superAdminOnboarding.catalogSelectedCategoriesItems,
});

export default connect(mapStateToProps, {
  delete_item_from_category,
  vendor_show_local_menu_items,
  vendor_copy_items_from_catalog,
})(SelectedItemsNew);

export const Accordian = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  return (
    <React.Fragment>
      <tbody>
        <tr className="super_admin_all_users_table_body text-break">
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: "25%" }}>
                    <div className="f10-400">#{props?.item._id}</div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <img
                      width="40px"
                      src={
                        props?.item?.images[0] ||
                        "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                      }
                    />
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f10-400">
                      {props?.item?.primary_food_type?.title}
                    </div>
                  </td>
                  <td style={{ width: "40%" }}>
                    <div className="f10-400">{props?.item?.category?.name}</div>
                  </td>
                </tr>
                {TrDetail && (
                  <tr className="border-top">
                    <td colSpan="4" style={{ width: "100%" }}>
                      <div className="mb-2 f10-500">Actions</div>
                      <div className="d-flex align-items-center">
                        <Button variant="link" className="enIconBtn mr-3">
                          <Image
                            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                            alt="View"
                            title="View"
                            fluid
                          />
                        </Button>
                        <NavLink
                          to="/casual-fine-dining/menusetup/selectmenu/editcategories"
                          variant="link"
                          className="enIconBtn mr-3"
                        >
                          <Image
                            src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="View"
                            title="View"
                            fluid
                          />
                        </NavLink>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
